import { lifecycle, compose, withState, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import Events from '../components/Events';
import { store } from 'store/createStore';
import { open } from 'store/modules/modal';
import API from '../../../../../utils/api';

const $lifecycle = lifecycle({
  componentDidMount() {
    try {
      if (this.props.location.state.channelId && this.props.location.state.channelName) {
        const { channelId, channelName } = this.props.location.state;

        this.props.fetchEvents(channelId, null, true);

        this.props.setChannelId(channelId);
        this.props.setChannelName(channelName);

        this.props.setGroup(store.getState().auth.currentGroup._id);
      } else {
        this.props.history.push('/dashboard/channel/admin');
      }
    } catch (error) {
      this.props.history.push('/dashboard/channel/admin');
    }
  },
  componentDidUpdate() {
    if (this.props.group !== store.getState().auth.currentGroup._id) {
      this.props.history.push('/dashboard/channel/admin');
    }
  },
});

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

const enhance = compose(
  connect(mapStateToProps),
  withState('channelId', 'setChannelId', null),
  withState('channelName', 'setChannelName', ''),
  withState('eventList', 'setEventList', []),
  withState('eventMyVersusList', 'setEventMyVersusList', []),
  withState('pageSize', 'setPageSize', 10),
  withState('group', 'setGroup', null),
  withState('showClosedEvents', 'setShowClosedEvents', false),
  withState('selectedTab', 'updateSelectedTab', 0),
  withState('leagueSelected', 'setLeagueSelected', null),
  withState('teamSelected', 'setTeamSelected', null),
  withHandlers({
    fetchEvents:
      props => (channelId, showClosedEvents, sortActiveMyVersus, leagueId, teamId) => {
        const league = leagueId !== undefined ? leagueId : props.leagueSelected;
        const team = teamId !== undefined ? teamId : props.teamSelected;

        const query = { channel: channelId };

        if (league) {
          query.league = league;
        }

        if (team) {
          query.teams = team;
        }

        if (showClosedEvents !== undefined && showClosedEvents !== null) {
          if (!showClosedEvents) {
            query.active = true;
          }
        } else if (!props.showClosedEvents) {
          query.active = true;
        }

        API.getChannelEvents({
          query: JSON.stringify(query),
          populateHosts: true,
          checkDependencies: true,
        }).then(({ data }) => {
          if (data && data.docs) {
            data = data.docs;
            const myVersusList = data.filter(event => {
              if (event.isMyVersusDemo) return true;
              return false;
            });
            if (sortActiveMyVersus) {
              myVersusList.sort((a, b) =>
                a.activeMyVersusDemo === b.activeMyVersusDemo
                  ? 0
                  : a.activeMyVersusDemo
                  ? -1
                  : 1
              );
            }
            data = data.filter(event => {
              if (!event.isMyVersusDemo) return true;
              return false;
            });

            props.setEventList(data);
            props.setEventMyVersusList(myVersusList);
            props.setLeagueSelected(league);
            props.setTeamSelected(team);
          }
        });
      },
    onChangeTab: props => (evt, value) => {
      props.updateSelectedTab(value);
    },
  }),
  withHandlers({
    changeFilter:
      props =>
      ({ league, team }) => {
        props.fetchEvents(
          props.channelId,
          props.showClosedEvents,
          null,
          league,
          league !== undefined && league !== props.leagueSelected ? null : team
        );
      },
    updateMyVersusDemo: props => (eventId, activeMyVersusDemo) => {
      API.updateChannelEvent(eventId, { activeMyVersusDemo }).then(() =>
        props.fetchEvents(props.channelId)
      );
    },
    updateShowClosed: props => () => {
      props.setShowClosedEvents(!props.showClosedEvents);
      props.fetchEvents(props.channelId, !props.showClosedEvents);
    },
    confirmDelete: props => row => {
      props.dispatch(
        open({
          modalType: 'confirm',
          modalProps: {
            message: `Delete Event ${row.name}?`,
            keyId: row._id,
            handleYes: () => {
              API.deleteChannelEvent(row._id).then(() => {
                props.fetchEvents(props.channelId);
              });
            },
          },
        })
      );
    },
  }),
  $lifecycle
);

export default enhance(Events);
